<template>
  <div>
    <main id="landing" class="utb-main">
      <utb-header></utb-header>
      <div class="container">
        <section id="intro" class="container mt2-sm mt3-md">
          <div class="utb-hero">
            <h1 class="h1 serif lh-text">Working together to rescue the oppressed, redeem the broken, and restore the hurting.</h1>
            <!-- <div class="fz1 mt2 fw700"><a href="#stories">Read Our Stories <i class="material-icons">arrow_downward</i></a></div> -->
          </div>
          <img class="utb-balloon" src="@/assets/balloon.svg" alt="Hot Air Balloon">
        </section>

        <utb-section-mission></utb-section-mission>
        <utb-section-projects></utb-section-projects>
        <utb-section-donate></utb-section-donate>
        <utb-section-get-in-touch></utb-section-get-in-touch>

      </div>
    </main>
    <utb-footer></utb-footer>
  </div>
</template>

<script>
import UtbHeader from './Header.vue'
import UtbFooter from './Footer.vue'
import UtbSectionMission from './Mission.vue'
import UtbSectionProjects from './Projects.vue'
import UtbSectionDonate from './Donate.vue'
import UtbSectionGetInTouch from './GetInTouch.vue'

export default {
  components: {
    UtbHeader: UtbHeader,
    UtbFooter: UtbFooter,
    UtbSectionMission: UtbSectionMission,
    UtbSectionProjects: UtbSectionProjects,
    UtbSectionDonate: UtbSectionDonate,
    UtbSectionGetInTouch: UtbSectionGetInTouch
  }
}
</script>

<style lang="scss">
@import '~@/styles/colors';
@import '~@/styles/media';

.utb-hero {
  grid-column: main;

  @include md {
    grid-column: main / span 7;

    .h1 {
      margin-top: 0em;
      font-weight: normal;
    }
  }

  @include lg {
    .h1 {
      margin-top: 1em;
      font-weight: normal;
    }
  }
}

.utb-balloon {
  width: 100%;
  grid-column: main;
  margin-top: 3em;

  @include md {
    grid-column: 9 / span full;
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue